const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M4.25 9.75A.75.75 0 0 1 5 9h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75m0 9A.75.75 0 0 1 5 18h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M5 13.5A.75.75 0 0 0 5 15h14a.75.75 0 0 0 0-1.5zm-.75-8.25A.75.75 0 0 1 5 4.5h14A.75.75 0 0 1 19 6H5a.75.75 0 0 1-.75-.75"/></svg>';
export {
  a as w
};
